// eslint-disable-next-line import/prefer-default-export
export const ACTIONS = [
  {
    name: 'pencil',
    title: 'Edit project',
  }, {
    name: 'trash',
    title: 'Remove project',
  },
  {
    name: 'colors',
    title: 'Add color',
  },
  {
    name: 'picture',
    title: 'Add image',
  },
];
